<template>
  <a-card :bodyStyle="{padding:'0 20px 20px'}">
    <base-sub-title title="园区企业"/>
    <a-spin :spinning="loading">
      <div class="screen-box">
        <a-input placeholder="请输入企业名称" v-model="screenData.companyName"></a-input>
        <a-select style="width:194px;margin-left:6px" v-model="screenData.ownFlag">
          <a-select-option key="0">所有</a-select-option>
          <a-select-option key="2">欠费</a-select-option>
          <a-select-option key="1">未欠费</a-select-option>
        </a-select>
        <a-button type="link" @click="screenSubmit">查询</a-button>
      </div>
      <div class="company-list">
        <ul>
          <li
            :class="['company-item', {cur: item.companyId === current.companyId}]"
            v-for="item in companyList"
            :key="item.companyId"
            @click="$emit('update:current', item)"
          >
            {{item.companyName}}<span v-if="item.ownFlag === '2'">（<i class="warn">欠费</i>）</span>
          </li>
        </ul>
      </div>
      <div class="pagination-box">
        <a-pagination
          size="small"
          :current="page.current"
          :pageSize="page.size"
          :total="page.total"
          @change="paginationChange"
        />
      </div>
    </a-spin>
  </a-card>
</template>

<script>
import { system } from '@/api'
import { reactive, toRefs, onMounted, onUnmounted } from '@vue/composition-api'
import { message } from 'ant-design-vue'

function setup (props, { root, emit }) {
  const state = reactive({
    loading: false,
    screenData: {
      companyName: '',
      ownFlag: '0'
    },
    companyList: [],
    page: {
      current: 1,
      size: 10,
      total: 0
    }
  })

  root.$bus.$on('Charge:updateCompanyList', getCompanyList)

  onMounted(() => {
    getCompanyList()
  })

  onUnmounted(() => {
    root.$bus.$off('Charge:updateCompanyList', getCompanyList)
  })

  async function getCompanyList () {
    state.loading = true
    let { code, msg, data, page } = await system.getCompanyList({
      ...state.screenData,
      ...state.page
    })
    state.loading = false
    if (code !== 0) return message.error(msg || '园区企业获取失败')
    state.companyList = data
    state.page.total = page.total
    if (data.length && !Object.keys(props.current).length) emit('update:current', data[0])
  }

  function paginationChange (current) {
    state.page.current = current
    getCompanyList()
  }

  function screenSubmit () {
    state.page.current = 1
    getCompanyList()
  }

  return {
    ...toRefs(state),
    paginationChange,
    screenSubmit
  }
}

export default {
  name: 'CompanyList',

  props: {
    current: Object
  },

  setup
}
</script>

<style lang="less" scoped>
.screen-box {
  display: flex;
  align-items: center;
}
.company-list {
  padding-top: 12px;
  .company-item {
    width: 100%;
    height: 40px;
    padding: 0 12px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    cursor: pointer;
    .el;
    &:hover,
    &.cur {
      color: @link-color;
      background-color: #F3F6F8;
    }
    .warn {
      color: @warning-color;
      font-style: normal;
    }
  }
}
.pagination-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
